"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SidebarToggle = _interopRequireDefault(require("./SidebarToggle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _SidebarToggle["default"];
exports["default"] = _default;